import MyOrders from './components/MyOrders'

export default MyOrders
